export enum OrganizationErrorCodes {
    NOT_FOUND = 'OrganizationDefectIds.Gen.ORGANIZATION_NOT_FOUND'
}
